export const ConfigStore = () => window.APPCONFIG;
